import IdleClockWrapper from './style/IdleClockWrapper';

const IdleClock = ({ duration }) => (
  <IdleClockWrapper duration={duration} className='d-flex justify-content-center'>
    <div className='clock' />
  </IdleClockWrapper>
);
export default IdleClock;
